<template>
    <aside
        class="aside"
        style="grid-column: 1;"
    >
        <nav
            class="aside__nav--sticky"
        >
            <NuxtLink
                v-for="item in items"
                :key="item.uri"
                class="aside__item"
                :class="{ active: item.active }"
                :to="'/'+item.uri"
            >
                {{ item.title }}
            </NuxtLink>
        </nav>
    </aside>
</template>

<script setup lang="ts">
type Props = {
    topItems?: any[];
    items?: any[];
    types?: string[];
    offset?: number;
}
defineProps<Props>();
</script>

<style lang="less" src="./TheAsideLinks.less"></style>
